import { useAppContext } from 'Context/ReactAppContext';
import React, { createContext, useContext } from 'react';
import { getB2BPaymentProviderLabel as _getB2BPaymentProviderLabel } from './B2BPaymentProvidersUtils';

const B2BPaymentViewContext = createContext({
  getB2BPaymentProviderLabel: () => false,
});

type B2BPaymentViewProviderProps = {
  children: React.Node;
  paymentProviders: $ReadOnlyArray<PaymentProvider>;
  paymentSchedule: PaymentSchedule;
};

export const B2BPaymentViewProvider = ({ children }: B2BPaymentViewProviderProps) => {
  const appContext = useAppContext();
  const { isCxo, isCmta } = appContext;

  const getLabelByCanal = ({ cxoLabel, cmtaLabel }) => {
    if (isCmta) {
      return cmtaLabel;
    }
    if (isCxo) {
      return cxoLabel;
    }
    return cxoLabel;
  };

  const { isSeller } = appContext;

  const getB2BPaymentProviderLabel = ({ paymentProvider, isTotalAmount }) =>
    isSeller && _getB2BPaymentProviderLabel({ paymentProvider, isTotalAmount, getLabelByCanal });

  return (
    <B2BPaymentViewContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        getB2BPaymentProviderLabel,
      }}
    >
      {children}
    </B2BPaymentViewContext.Provider>
  );
};

export const useB2BPaymentViewContext = () => {
  return useContext(B2BPaymentViewContext);
};
